import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_UNIT_DISPLAY, sanitizeUnitDisplay } from "./unitDisplay";
import type { UnitDisplaySettings } from "./types";

interface UnitDisplayState {
  settings: UnitDisplaySettings;
  update: (patch: Partial<UnitDisplaySettings>) => void;
  reset: () => void;
}

export const useUnitDisplayStore = create<UnitDisplayState>()(
  persist(
    (set) => ({
      settings: DEFAULT_UNIT_DISPLAY,
      update: (patch) => set((state) => ({ settings: sanitizeUnitDisplay({ ...state.settings, ...patch }) })),
      reset: () => set({ settings: DEFAULT_UNIT_DISPLAY }),
    }),
    {
      name: "dumax.unitDisplay",
      version: 1,
      partialize: (state) => ({ settings: state.settings }),
      merge: (persisted, current) => ({
        ...current,
        settings: sanitizeUnitDisplay((persisted as { settings?: unknown } | undefined)?.settings),
      }),
    },
  ),
);

export const useUnitDisplay = (): UnitDisplaySettings => useUnitDisplayStore((state) => state.settings);
